var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.data.listStyle === 'unordered' ? 'ul' : 'ol',{tag:"component",class:['editorList', `editorList--${_vm.data.style}`]},_vm._l((_vm.data.items),function(item,index){return _c('li',{key:index,domProps:{"innerHTML":_vm._s(item)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }